import { createFileRoute, Outlet } from "@tanstack/react-router"
import { createServerFn } from "@tanstack/react-start"
import { getRequestHeader } from "@tanstack/react-start/server"

import { requireSession } from "@/auth/rpc"
import { AppShell } from "@/crm/components/layout/app-shell"
import { isMobileUserAgent, ViewportProvider } from "@/crm/lib/viewport"

/**
 * Resolves the form factor on the server so the first paint already matches
 * the device — `matchMedia` corrects it after hydration if needed.
 */
const getViewportHint = createServerFn({ method: "GET" }).handler(async () => ({
  isMobile: isMobileUserAgent(getRequestHeader("user-agent")),
}))

export const Route = createFileRoute("/_crm")({
  beforeLoad: async () => {
    await requireSession()
  },
  loader: async () => getViewportHint(),
  component: CrmLayout,
})

function CrmLayout() {
  const { isMobile } = Route.useLoaderData()

  return (
    <ViewportProvider initialIsMobile={isMobile}>
      <AppShell>
        <Outlet />
      </AppShell>
    </ViewportProvider>
  )
}
